import {
    GET_REMOVE_CONVERSATION_AUTOMATION_DATA,
    TOGGLE_REMOVE_CONVERSATION_SETTINGS_VIEW,
    TOGGLE_REMOVE_CONVERSATION_AUTOMATION,
    CREATE_REMOVE_CONVERSATION_AUTOMATION,
    UPDATE_REMOVE_CONVERSATION_AUTOMATION
  } from '../actionTypes';
  
  const initialState = {};
  
  export const removedConversationReducer = (state = initialState, action) =>{
    const {payload} = action;
    switch(action.type) {
      case `${GET_REMOVE_CONVERSATION_AUTOMATION_DATA}_SUCCESS`:
        const {smId, schedule, emails, timezone,enabled,updated_by,updated_at} = payload;
        return {
            ...state,
            [smId]: {
              ...(state[smId] || {}),
              data: schedule ? {
                schedule, 
                emails, 
                timezone,
                enabled,
                updated_by,
                updated_at
              } : null,
            }
        }

        case TOGGLE_REMOVE_CONVERSATION_SETTINGS_VIEW: {
          const {status, smId} = payload;
          return {
            ...state,
            [smId]: {
              ...(state[smId] || {}),
              configureActive: status,
            }
          }
        }

        case `${TOGGLE_REMOVE_CONVERSATION_AUTOMATION}_SUCCESS`: {
          const {enabled, smId} = payload;
          return {
            ...state,
            [smId]: {
              ...(state[smId] || {}),
              data: {
                ...(state[smId].data || {}),
                enabled,
              },
            }
          }
        }

        case `${CREATE_REMOVE_CONVERSATION_AUTOMATION}_SUCCESS`:
        case `${UPDATE_REMOVE_CONVERSATION_AUTOMATION}_SUCCESS`:
        {
          const {smId, schedule, emails, timezone, updated_by,updated_at, enabled} = payload;
          return {
              ...state,
              [smId]: {
                ...(state[smId] || {}),
                data: {
                  ...(state[smId].data || {}),
                  schedule: {
                    ...(state[smId]['schedule'] || {}),
                    ...schedule
                  },
                  timezone,
                  emails,
                  updated_by,
                  updated_at,
                  enabled
                },
              }
          }
        }

      default:
        return state;
    }
  }
  
